var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ma-3"},[_c('v-data-table',{attrs:{"headers":_vm.stoveHeaders,"items":_vm.stoves},scopedSlots:_vm._u([{key:`item.energyEfficiency`,fn:function({ item }){return [_vm._v(" "+_vm._s(item.energyEfficiency * 100)+" ")]}}],null,true)})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }